import { useApi } from "hooks"
import { useMutation } from "@tanstack/react-query"
import { RECAPTCHA_TYPES } from "config/constants"

const useRegister = () => {

  const { apiFetch } = useApi()

  const url = `/auth/register`;

  const register = ({
    mobileNumber,
    email,
    nickname,
    password
  }) => {
    return apiFetch({
      url,
      method: 'POST',
      data: {
        mobileNumber,
        email,
        nickname,
        password
      },
      captcha: {
        type: RECAPTCHA_TYPES.v3,
        action: 'register'
      }
    })
      .then( res => res.data)
  }

  const {
    mutate,
    ...rest
  } = useMutation(register)

  return {
    register: mutate,
    ...rest
  }

}

export default useRegister
